import React, { useState, useMemo } from "react";
import "../../cstm.style.css";
import { MaterialReactTable } from "material-react-table";
// import FullScreenLoader from "../../components/FullScreenLoader";


// Dummy data – replace with real data
const disbursalData = [
  {
    id: 1,
    date: "2025-12-01",
    customer_name: "Rahul Sharma",
    product: "DSA",
    amount: 100000,
    status: "Disbursed",
  },
];

const collectionData = [
  {
    id: 1,
    date: "2025-12-02",
    customer_name: "Ankit Verma",
    product: "DealX",
    amount: 25000,
    status: "Collected",
  },
];

const aumData = [
  {
    id: 1,
    date: "2025-12-03",
    product: "DSA",
    customer_count: 50,
    principal_outstanding: 2500000,
  },
];

export default function Reports() {
  const [activeTab, setActiveTab] = useState("disbursal"); // 'disbursal' | 'collection' | 'aum'

  const disbursalColumns = useMemo(
    () => [
      { accessorKey: "date", header: "Date" },
      { accessorKey: "customer_name", header: "Customer" },
      { accessorKey: "product", header: "Product" },
      {
        accessorKey: "amount",
        header: "Amount",
        Cell: ({ cell }) => `₹${cell.getValue() || 0}`,
      },
      { accessorKey: "status", header: "Status" },
    ],
    []
  );

  const collectionColumns = useMemo(
    () => [
      { accessorKey: "date", header: "Date" },
      { accessorKey: "customer_name", header: "Customer" },
      { accessorKey: "product", header: "Product" },
      {
        accessorKey: "amount",
        header: "Collected",
        Cell: ({ cell }) => `₹${cell.getValue() || 0}`,
      },
      { accessorKey: "status", header: "Status" },
    ],
    []
  );

  const aumColumns = useMemo(
    () => [
      { accessorKey: "date", header: "Date" },
      { accessorKey: "product", header: "Product" },
      {
        accessorKey: "customer_count",
        header: "Customers",
      },
      {
        accessorKey: "principal_outstanding",
        header: "Principal Outstanding",
        Cell: ({ cell }) => `₹${cell.getValue() || 0}`,
      },
    ],
    []
  );

  return (
    <div className="page-bg">
      <div className="title-header">
        <div className="title-icon">
          <h2 className="page-title">Reports</h2>
        </div>
      </div>

      {/* Tabs */}
      <div style={styles.tabsContainer}>
        <button
          type="button"
          onClick={() => setActiveTab("disbursal")}
          style={{
            ...styles.tabButton,
            ...(activeTab === "disbursal" ? styles.tabButtonActive : {}),
          }}
        >
          Disbursal
        </button>
        <button
          type="button"
          onClick={() => setActiveTab("collection")}
          style={{
            ...styles.tabButton,
            ...(activeTab === "collection" ? styles.tabButtonActive : {}),
          }}
        >
          Collection
        </button>
        <button
          type="button"
          onClick={() => setActiveTab("aum")}
          style={{
            ...styles.tabButton,
            ...(activeTab === "aum" ? styles.tabButtonActive : {}),
          }}
        >
          AUM
        </button>
      </div>

      {/* Tables */}
      <div className="table-cntnr" style={{ overflowX: "auto" }}>
        {activeTab === "disbursal" && (
          <MaterialReactTable columns={disbursalColumns} data={disbursalData} />
        )}

        {activeTab === "collection" && (
          <MaterialReactTable
            columns={collectionColumns}
            data={collectionData}
          />
        )}

        {activeTab === "aum" && (
          <MaterialReactTable columns={aumColumns} data={aumData} />
        )}
      </div>
    </div>
  );
}

const styles = {
  tabsContainer: {
    display: "inline-flex",
    borderBottom: "1px solid #e5e7eb",
    marginBottom: "1rem",
    gap: "0.5rem",
  },
  tabButton: {
    padding: "0.4rem 0.9rem",
    border: "none",
    borderBottom: "2px solid transparent",
    background: "transparent",
    cursor: "pointer",
    fontSize: "0.95rem",
    color: "#6b7280",
  },
  tabButtonActive: {
    borderBottomColor: "#7c3aed",
    color: "#111827",
    fontWeight: 600,
  },
};
